import { FilterDateRange } from "@/presentation/deduction/components/DeductionFilter/interfaces";
import { SelectOption } from "@ir/ui";
import { atom } from "jotai";

export const DEFAULT_DEDUCTION_FILTER_PROPS: (keyof FilterInfo)[] = ["checkFromDate", "checkToDate", "checkDateRange"];

type Option = SelectOption;

export interface FilterInfo {
  invoiceFromDate: string | null;
  invoiceToDate: string | null;
  checkFromDate: string | null;
  checkToDate: string | null;
  checkDateRange: string | null;
  invoiceDateRange: string | null;
  purchaser: Option[];
  dc: Option[];
  priority: Option[];
  validity: Option[];
  adjustmentTypes: Option[];
  adjustmentCategories: Option[];
  deductionTypeCategories: Option[];
  poNumberSearch: string | null;
  retailer: Option[];
  analyst: Option[];
  approver: Option[];
  progress: Option[];
}
export interface QuickFIlterInfo {
  statusId: "all" | "incomplete" | number;
}
export interface DeductionFilterState {
  isFilterApplied: boolean;
  filterInfo: FilterInfo;
  quickFilterInfo: QuickFIlterInfo;
}

const initialState: DeductionFilterState = {
  isFilterApplied: false,
  filterInfo: {
    invoiceFromDate: null,
    invoiceToDate: null,
    checkFromDate: null,
    checkToDate: null,
    checkDateRange: FilterDateRange.LAST_3_MONTHS,
    invoiceDateRange: null,
    purchaser: [],
    dc: [],
    priority: [],
    validity: [],
    adjustmentTypes: [],
    adjustmentCategories: [],
    deductionTypeCategories: [],
    poNumberSearch: null,
    retailer: [],
    analyst: [],
    approver: [],
    progress: [],
  },
  quickFilterInfo: {
    statusId: "all",
  },
};

// Base atoms
export const deductionFilterAtom = atom<DeductionFilterState>(initialState);

// Derived atoms for specific states
export const filterInfoAtom = atom(get => get(deductionFilterAtom).filterInfo);
export const isFilterAppliedAtom = atom(get => get(deductionFilterAtom).isFilterApplied);
export const quickFilterInfoAtom = atom(get => get(deductionFilterAtom).quickFilterInfo);
